import { Component } from '@angular/core';

@Component({
  selector: 'app-page-not-found',
  template: `<div class="not-found"><h1>404 - Page Not Found</h1><p>The page you are looking for does not exist.</p></div>`,
  styles: [`.not-found { text-align: center; margin-top: 100px; }`]
})
export class PageNotFoundComponent {}
